const C = {
  name: "Microphone2",
  dimensions: { width: 24, height: 41 },
  content: `
    <g clip-path="url(#clip0_12_5104)">
    <path d="M9 18.0029H6V15.0029H9C9.55 15.0029 10 14.5529 10 14.0029C10 13.4529 9.55 13.0029 9 13.0029H6V10.0029H9C9.55 10.0029 10 9.55293 10 9.00293C10 8.45293 9.55 8.00293 9 8.00293H6C6 4.69293 8.69 2.00293 12 2.00293C15.31 2.00293 18 4.69293 18 8.00293H15C14.45 8.00293 14 8.45293 14 9.00293C14 9.55293 14.45 10.0029 15 10.0029H18V13.0029H15C14.45 13.0029 14 13.4529 14 14.0029C14 14.5529 14.45 15.0029 15 15.0029H18V18.0029H15C14.45 18.0029 14 18.4529 14 19.0029C14 19.5529 14.45 20.0029 15 20.0029H18C18 23.3129 15.31 26.0029 12 26.0029C8.69 26.0029 6 23.3129 6 20.0029H9C9.55 20.0029 10 19.5529 10 19.0029C10 18.4529 9.55 18.0029 9 18.0029ZM12 28.0029C16.41 28.0029 20 24.4129 20 20.0029V8.00293C20 3.59293 16.41 0.00292969 12 0.00292969C7.59 0.00292969 4 3.59293 4 8.00293V20.0029C4 24.4129 7.59 28.0029 12 28.0029Z" fill="currentColor"/>
    <path d="M24 20.0029C24 19.4529 23.55 19.0029 23 19.0029C22.45 19.0029 22 19.4529 22 20.0029C22 25.5129 17.51 30.0029 12 30.0029C6.49 30.0029 2 25.5129 2 20.0029C2 19.4529 1.55 19.0029 1 19.0029C0.45 19.0029 0 19.4529 0 20.0029C0 26.2829 4.85 31.4429 11 31.9529V38.0029H5C4.45 38.0029 4 38.4529 4 39.0029C4 39.5529 4.45 40.0029 5 40.0029H19C19.55 40.0029 20 39.5529 20 39.0029C20 38.4529 19.55 38.0029 19 38.0029H13V31.9529C19.15 31.4429 24 26.2829 24 20.0029Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_12_5104">
    <rect width="24" height="40" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>

  `
};
export {
  C as Microphone2
};
